import styled from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import Speaker from '../assets/speaker.svg';
import { OnboardingStages, useOnboardingStore } from '../Store';

const SpeakerIcon = styled(Speaker)`
  max-width: 77px;
  fill: #e0e0e0;
`;

export const Volume = () => {
  const { stage, next } = useOnboardingStore();
  return (
    <Flex
      variant="list"
      justifyContent="space-between"
      data-test-id="volume-card"
    >
      <h2>{t`Turn on the volume`}</h2>
      <Flex variant="center" w="auto" h="auto">
        <SpeakerIcon />
      </Flex>
      <small>
        {t`This training works best with the sound on. Make sure to adjust the volume.`}
      </small>
      <Button
        onClick={next}
        disabled={stage !== OnboardingStages.Volume}
        aria-hidden={stage !== OnboardingStages.Volume}
        data-test-id="next-button"
      >
        {t`Next`}
      </Button>
    </Flex>
  );
};
